import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { CornerDialog } from "azure-devops-ui/Dialog";
import { Observer } from "azure-devops-ui/Observer";
import { ObservableValue } from "azure-devops-ui/Core/Observable";

export default class CornerDialogExample extends React.Component {
    private isDialogOpen = new ObservableValue<boolean>(false);

    public render() {
        const onDismiss = () => {
            this.isDialogOpen.value = false;
        };
        return (
            <div>
                <Button
                    text="Open Dialog"
                    onClick={() => {
                        this.isDialogOpen.value = true;
                    }}
                />
                <Observer isDialogOpen={this.isDialogOpen}>
                    {(props: { isDialogOpen: boolean }) => {
                        return props.isDialogOpen ? (
                            <CornerDialog
                                onDismiss={onDismiss}
                                footerButtonProps={[
                                    {
                                        href:  "https://www.azure.com/devops",
                                        target: "_blank",
                                        text: "Learn more"
                                    },
                                    {
                                        primary: true,
                                        onClick: () => alert("Feature Enabled"),
                                        text: "Try it"
                                    }
                                ]}
                                titleProps={{
                                    text: "New release progress views"
                                }}
                            >
                                <div className="flex-column">
                                    <span className="body-m">
                                        Turn on the new release views to visualize the progress of
                                        your deployment pipelines.
                                    </span>
                                </div>
                            </CornerDialog>
                        ) : null;
                    }}
                </Observer>
            </div>
        );
    }
}
